import React from "react";
import { useTranslation } from "react-i18next";
import { CustomIconsAssociateModal } from "./CustomIconsAssociateModal";
import { DisplayName } from "../DisplayName";

export function ArrayOfCustomColumnsAssociateModal(
    isArchivedLanguagesClicked: boolean
) {
    const { t } = useTranslation();
    return [
        {
            indexOFColumn: 2,
            columnName: t("Language"),
            customJsx: (e: any) => <NumberLangues e={e} />,
        },
        {
            indexOFColumn: 1,
            columnName: t("Display name"),
            customJsx: (e: any) => <DisplayName e={e} />,
        },
        {
            indexOFColumn: 3,
            columnName: t("Country"),
            customJsx: (e: any) => <GetCountry e={e} />,
        },
        {
            indexOFColumn: 7,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIconsAssociateModal
                    e={e}
                    isArchivedLanguagesClicked={isArchivedLanguagesClicked}
                />
            ),
        },
    ];
}

function NumberLangues(e: any) {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            {e.e.selectedRow?.subRows !== undefined ? (
                <h6 className="badge__clz">
                    {e.e.selectedRow[t("Shop")] !== ""
                        ? e.e.selectedRow.subRows?.length
                        : 0}
                </h6>
            ) : (
                e.e.selectedRow[t("Language")]
            )}
        </React.Fragment>
    );
}

function GetCountry(e: any) {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            {e.e.selectedRow?.subRows !== undefined
                ? e.e.selectedRow.pays
                : e.e.selectedRow[t("Country")]}
        </React.Fragment>
    );
}
